import OutLineMobileNine from '@assets/icons/outline-mobile-nine.svg'
import { Icon } from './Icon'

export const OutLineMobileNineIcon = Icon(OutLineMobileNine)
